import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Store } from "@ngrx/store";
import { Actions } from "@ngrx/effects";
import { AppState } from "@store/app-state";
import { Subscription } from "rxjs/Subscription";
import { CommsStore } from "@store/comms";
import {
  RELOAD_EMAIL_TEMPLATES_SUCCESS,
  FETCH_TEMPLATES,
  RELOAD_EMAIL_TEMPLATES
} from "@reducers/comms";

@Component({
  selector: 'comms-view',
  templateUrl: './comms-view.pug',
})
export class CommsViewComponent implements OnInit, OnDestroy {

  public activeTab: string = "email"
  public isComposing: boolean = false
  public isReloadingTemplates: boolean = false

  private commsSubscription: Subscription

  constructor(
    private store: Store<AppState>,
    private actions: Actions,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.commsSubscription =
      this.store.select("commsReducer")
        .subscribe((s: CommsStore) => {
        })

    this.checkParams()
  }

  checkParams() {
    const queryParams = this.activatedRoute.snapshot.queryParams
    this.activeTab = queryParams.tab || "email"

    if (queryParams.mode == "composing") { this.isComposing = true }
  }

  isTabActive(tab: string): boolean {
    return tab == this.activeTab
  }

  clickedTab(tab: string) {
    this.activeTab = tab
    this.isComposing = false

    this.router.navigate(['/communications'], { queryParams: {
      tab: this.activeTab } })
  }

  clickedCompose() {
    this.isComposing = true

    this.router.navigate(['/communications'], { queryParams: {
      tab: this.activeTab, mode: "composing" } })
  }

  clickedReloadTemplates() {
    this.isReloadingTemplates = true

    this.actions
      .ofType(RELOAD_EMAIL_TEMPLATES_SUCCESS)
      .take(1)
      .subscribe(() => {
        this.isReloadingTemplates = false
        this.store.dispatch({ type: FETCH_TEMPLATES })
      })

    this.store.dispatch({ type: RELOAD_EMAIL_TEMPLATES })
  }

  isReloadEmailTemplatesBtnVisible(): boolean {
    return this.isTabActive('email')
  }

  ngOnDestroy() {
    this.commsSubscription.unsubscribe()
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/comms-view.ts